import { render, staticRenderFns } from "./UserSelectorMultiple.vue?vue&type=template&id=278cd4d5&scoped=true&"
import script from "./UserSelectorMultiple.vue?vue&type=script&lang=js&"
export * from "./UserSelectorMultiple.vue?vue&type=script&lang=js&"
import style0 from "./UserSelectorMultiple.vue?vue&type=style&index=0&id=278cd4d5&lang=scss&scoped=true&"
import style1 from "./UserSelectorMultiple.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "278cd4d5",
  null
  
)

export default component.exports